import styles from "./SvgContainer3.module.css"

const SvgContainer3 = () => {
    return (
      <div className={styles.svgContainer}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1812"
          height="1757"
          viewBox="0 0 1512 857"
                fill="none"
                className={styles.whiteSvg}
        >
          <path
            d="M-35.8993 691.479C-37.6127 706.94 -18.1156 739.143 73.1755 744.203C169.554 749.545 182.333 766.167 194.506 782.001C196.746 784.915 198.966 787.802 201.682 790.587C219.159 808.508 246.916 826.429 344.581 812.198C442.246 797.966 537.855 793.222 610.847 826.956C669.241 853.943 725.767 857 746.55 857C767.334 857 823.86 853.943 882.253 826.956C955.245 793.222 1050.85 797.966 1148.52 812.198C1246.18 826.429 1273.94 808.508 1291.42 790.587C1294.13 787.802 1296.35 784.915 1298.59 782.001C1310.77 766.167 1323.55 749.545 1419.93 744.203C1511.22 739.143 1530.61 706.956 1528.9 691.495V0H1527.65C1521.8 16.4906 1495.49 39.2663 1419.93 43.4548C1323.55 48.7969 1310.77 65.4184 1298.59 81.2526C1296.35 84.1663 1294.13 87.0534 1291.42 89.8386C1273.94 107.76 1246.18 125.68 1148.52 111.449C1050.85 97.2177 955.245 92.474 882.253 126.208C823.86 153.194 767.334 156.252 746.55 156.252C725.767 156.252 669.241 153.194 610.847 126.208C537.855 92.474 442.246 97.2177 344.581 111.449C246.916 125.68 219.159 107.76 201.682 89.8386C198.966 87.0534 196.746 84.1663 194.506 81.2526C182.333 65.4184 169.554 48.7969 73.1755 43.4548C-2.39128 39.2663 -28.6969 16.4906 -34.5452 0H-35.7982L-35.8993 691.479Z"
            fill="#F3E6E2"
          />
        </svg>
        
      </div>
    )
}

export default SvgContainer3
